import { v4 as uuidv4 } from 'uuid';
import { FlexLayoutCol, FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { RichText } from '../../../../vtex-apps/rich-text/RichText/default';
import { NewsletterForm } from '../../../../vtex-apps/store-newsletter/NewsletterForm/default';
import { NewsletterInputEmail } from '../../../../vtex-apps/store-newsletter/NewsletterInputEmail/default';
import { NewsletterInputName } from '../../../../vtex-apps/store-newsletter/NewsletterInputName/default';
import { NewsletterSubmit } from '../../../../vtex-apps/store-newsletter/NewsletterSubmit/default';
import { VisibilityLayout } from '../../../../vtex-apps/VisibilityLayout/default';
import { NewsletterCheckboxConfirmation } from '../../../../vtex-apps/store-newsletter/NewsletterCheckboxConfirmation/default';

export default function Newsletter() {
	return {
		componentName: 'VisibilityLayout',
		componentId: uuidv4(),
		componentGroup: 'Newsletter',
		props: VisibilityLayout({ mzTitle: 'MZ | Newsletter (On/Off)' }).props,
		variables,
		childrenComponents: [
			FlexLayoutRow(
				{
					blockClass: 'footer-newsletter-3__row',
					colSizing: 'equal',
					preserveLayoutOnMobile: true,
					fullWidth: true,
					mzTitle: 'MZ | Newsletter',
				},
				[
					NewsletterForm({ blockClass: 'footer__newsletter-3' }, [
						FlexLayoutRow(
							{
								blockClass: 'footer-row__newsletter-3',
							},
							[
								FlexLayoutCol(
									{
										blockClass: 'footer-col__newsletter-3',
									},
									[
										RichText({
											text: 'Receba descontos e novidades diretamente no seu e-mail',
											blockClass: ['footer-rich-text__newsletter-3'],
										}),
										FlexLayoutRow(
											{
												blockClass: 'footer-split-container__newsletter-3',
												colSizing: 'equal',
											},
											[
												FlexLayoutRow(
													{
														blockClass: 'footer-inner-left__newsletter-3',
														colSizing: 'auto',
													},
													[
														RichText({
															blockClass: 'bullet-point__newsletter-3',
															textAlignment: 'LEFT',
															text: 'Receba nossos descontos antes de todos diretamente no seu e-mail e economize.',
														}),
														RichText({
															blockClass: 'bullet-point__newsletter-3',
															textAlignment: 'LEFT',
															text: 'Fique sabendo em primeira mão dos novos produtos na nossa loja.',
														}),
														RichText({
															blockClass: 'bullet-point__newsletter-3',
															textAlignment: 'LEFT',
															text: 'Ganhe cupons de desconto que são exclusivos para quem é inscrito.',
														}),
													],
												),
												FlexLayoutRow(
													{
														blockClass: 'footer-inner-right__newsletter-3',
														colSizing: 'auto',
													},
													[
														NewsletterInputName({
															blockClass: 'newsletter__input-name-3',
															placeholder: 'Ex: josé',
															inputLabel: 'Informe seu nome',
														}),
														NewsletterInputEmail({
															blockClass: 'newsletter__input-email-3',
															placeholder: 'Seu e-mail',
															inputLabel: 'Informe seu email',
														}),
														FlexLayoutRow(
															{
																blockClass: ['footer-inner-row__newsletter-last-3'],
																colSizing: 'auto',
															},
															[
																NewsletterCheckboxConfirmation({
																	blockClass: 'footer-3',
																	checkboxLabel: ' ',
																}),
																RichText({
																	mzTitle: 'MZ | Newsletter - políticas',
																	text: 'Ao se cadastrar você irá concordar com a nossa [Política de Privacidade](/politica-de-privacidade) e poderá alterar ou cancelar a newsletter a qualquer momento que desejar. Aqui você economiza nas suas compras e não recebe spam.',
																	blockClass: ['newsletter__help-message-checkbox-3'],
																}),
															],
														),
														NewsletterSubmit({
															blockClass: 'newsletter__submit-button-3',
															submitButtonLabel: 'Cadastrar',
														}),
													],
												),
											],
										),
									],
								),
							],
						),
					]),
				],
			),
		],
	};
}

const variables = [
	{
		type: 'color',
		list: [
			{
				from: '--brand-color-primary-pure',
				to: '--newsletter-3-background-color',
				name: 'Background Color',
			},
			{ from: '--white', to: '--newsletter-3-text-color', name: 'Text Color' },
			{ from: '--white', to: '--newsletter-3-input-border-color', name: 'Input Border Color' },
			{ from: '--transparent', to: '--newsletter-3-input-hover-color', name: 'Input Hover Color' },
			{ from: '--cta-color-pure', to: '--newsletter-3-cta-pure', name: 'CTA Color' },
			{ from: '--cta-color-focus', to: '--newsletter-3-cta-focus', name: 'CTA Hover Color' },
			{ from: '--cta-color-hover', to: '--newsletter-3-cta-hover', name: 'CTA Focus Color' },
			{ from: '--white', to: '--newsletter-3-cta-text-color', name: 'CTA Text Color' },
			{ from: '--white', to: '--newsletter-3-check-icon', name: 'Check Icon' },
			{ from: '--white', to: '--newsletter-3-politicas-link', name: 'Políticas Link Color' },
		],
	},
	{
		type: 'borderRadius',
		list: [{ from: '--border-radius-none', to: '--newsletter-3-border-radius', name: 'Border Radius' }],
	},
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-xxl', to: '--newsletter-3-header-desktop-size', name: 'Header Desktop Size' },
			{ from: '--font-size-xl', to: '--newsletter-3-header-mobile-size', name: 'Header Mobile Size' },
			{ from: '--font-size-sm', to: '--newsletter-3-input-size', name: 'Input Font Size' },
			{ from: '--font-size-sm', to: '--newsletter-3-cta-size', name: 'CTA Font Size' },
			{ from: '--font-size-xs', to: '--newsletter-3-info-size', name: 'Infotext Font Size' },
		],
	},
	{
		type: 'typography',
		list: [
			{ from: '--main-font', to: '--newsletter-3-header-font', name: 'Headline Font Family' },
			{ from: '--main-font', to: '--newsletter-3-body-font', name: 'Body Font Family' },
			{ from: '--main-font', to: '--newsletter-3-cta-font', name: 'CTA Font Family' },
		],
	},
];
